import React from 'react';

const AppleLogo = () => (
  <svg aria-hidden="true" className="h-5 w-5 fill-current" viewBox="0 0 24 24">
    <path d="M16.37 12.64c.02 2.29 2.01 3.05 2.03 3.06-.02.05-.31 1.08-1.02 2.13-.61.91-1.24 1.81-2.24 1.83-.98.02-1.3-.58-2.43-.58-1.14 0-1.49.56-2.41.6-.95.04-1.67-.95-2.29-1.86-1.26-1.83-2.22-5.16-.93-7.4.64-1.12 1.79-1.84 3.04-1.86.95-.02 1.84.64 2.43.64.58 0 1.67-.79 2.82-.67.48.02 1.83.19 2.7 1.46-.07.05-1.61.94-1.59 2.79Zm-1.99-5.74c.51-.62.85-1.48.75-2.34-.73.03-1.61.49-2.13 1.11-.47.55-.88 1.43-.77 2.28.81.06 1.64-.41 2.15-1.05Z" />
  </svg>
);

const AppleAuthButton = ({
  label,
  onClick,
  disabled = false,
  className = '',
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`flex w-full items-center justify-center gap-3 rounded-xl border border-white/10 bg-black px-4 py-4 text-sm font-semibold text-white transition hover:bg-[#111111] focus:outline-none focus-visible:ring-2 focus-visible:ring-white/25 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-900 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50 ${className}`.trim()}
  >
    <AppleLogo />
    <span>{label}</span>
  </button>
);

export default AppleAuthButton;
